import { render, staticRenderFns } from "./simple.vue?vue&type=template&id=ae2d0842&"
import script from "./simple.vue?vue&type=script&lang=ts&"
export * from "./simple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ThemeToggle: require('/home/forge/portal.gradlinc.co.za/releases/20260824084656/components/global/ThemeToggle.vue').default,ButtonTertiary: require('/home/forge/portal.gradlinc.co.za/releases/20260824084656/components/buttons/ButtonTertiary.vue').default})
